import type { MediaAsset } from '@ve/core';

/**
 * Logical (layout) size of a decoded frame. Proxies are decoded at reduced resolution, but layout
 * must use the original media size so `fit: none` and pixel positions stay identical between preview
 * and export. The aspect ratio is taken from the decoded frame (it already includes rotation).
 */
export function logicalSize(
  asset: Pick<MediaAsset, 'width' | 'height'> | undefined,
  decodedWidth: number,
  decodedHeight: number,
): { width: number; height: number } {
  if (decodedWidth <= 0 || decodedHeight <= 0) return { width: 0, height: 0 };
  const aw = asset?.width;
  const ah = asset?.height;
  if (!aw || !ah) return { width: decodedWidth, height: decodedHeight };
  const decodedLandscape = decodedWidth >= decodedHeight;
  const assetLandscape = aw >= ah;
  // Rotated media: the probe may report coded (unrotated) dimensions.
  const longSide = Math.max(aw, ah);
  const width = decodedLandscape === assetLandscape ? aw : decodedLandscape ? longSide : Math.min(aw, ah);
  return { width, height: Math.round((width * decodedHeight) / decodedWidth) };
}
